import { destructRefund, destructStatus } from '../../destructerers';
import { executeRequest } from '../request';

const executeRefund = async context => {
  // take built payload
  const { transactionId, config } = context;

  let adyenResponse;
  let status = false;

  // make request
  logger.info(
    `[Adyen/Refund] [TX${transactionId}] - Refund request: ${JSON.stringify(context, null, 2)}`,
  );

  try {
    adyenResponse = await executeRequest({ context });

    logger.info(
      `[Adyen/Refund] [TX${transactionId}] - Raw refund response received: ${JSON.stringify(
        adyenResponse,
        null,
        2,
      )}`,
    );

    // handle destruct
    // return standard format
    const { result, errorCondition, response } = destructRefund({
      response: adyenResponse,
      config,
    });

    if (result === 'success') {
      logger.info(`[Adyen/Refund] [TX${transactionId}] - Refund processed successfully`);
      return Promise.resolve({ result, errorCondition, response });
    }

    throw new Error('Refund failed');
  } catch (error) {
    logger.error(`[Adyen/Refund] [TX${transactionId}] - Refund request failed`, error);

    logger.info(`[Adyen/Recovery] [TX${transactionId}] - Checking refund status`);
    adyenResponse = await executeRequest({ context, status: true });

    status = true;

    logger.info(
      `[Adyen/Recovery] [TX${transactionId}] - Raw refund status response received: ${JSON.stringify(
        adyenResponse,
        null,
        2,
      )}`,
    );

    // handle destruct
    // return standard format
    const { result, errorCondition, response } = destructStatus({
      response: adyenResponse,
      config,
      status,
    });

    if (result === 'success') {
      logger.info(`[Adyen/Refund] [TX${transactionId}] - Refund successful after status check`);
      return Promise.resolve({ result, errorCondition, response });
    }

    logger.error(
      `[Adyen/Refund] [TX${transactionId}] - Refund failed  - Reason: ${errorCondition}`,
    );
    return Promise.reject({ result, errorCondition, response });
  }
};

export { executeRefund };
